module.exports = __webpack_public_path__ + "img/arrow-down.83119e29.svg";